import { SectionNotificationType } from 'wix-ui-tpa';
import { isMobile } from './services/wixServices';
import WIDGET_SIZE from './enums/widgetSize';

export const AppDefId = '12d5833e-f061-7cc8-5122-e1d404f6c8ae';

const DEFAULT_DIMENSIONS = {
  [WIDGET_SIZE.responsive]: { width: 1, height: 3 },
  [WIDGET_SIZE.fixed]: { width: 336, height: 280 },
};

export default DEFAULT_DIMENSIONS;
export const ADS_BASE = 'https://wixlabs-adsense-v3.uc.r.appspot.com';
export const ADS_API_INSTANCES_URL = `${ADS_BASE}/api/v2/instances`;
export const ADS_API_ADUNITS_URL = `${ADS_BASE}/api/v2/adunits`;
export const ADS_API_FIRST_SETUP = `${ADS_BASE}/api/v2/first_setup`;

export const GOOGLE_ADS_GENERATOR_SCRIPT =
  'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
export const GOOGLE_ADS_META_PLATFORM_ACCOUNT_NAME =
  'google-adsense-platform-account';
export const GOOGLE_ADS_META_PLATFORM_ACCOUNT_CONTENT =
  'ca-host-pub-6654278186409559';
export const GOOGLE_ADS_META_PLATFORM_DOMAIN_NAME =
  'google-adsense-platform-domain';
export const GOOGLE_ADS_META_PLATFORM_DOMAIN_CONTENT = 'https://wix.com';
export const GOOGLE_ADS_META_PLATFORM_AUTHOR_URL_NAME =
  'google-adsense-platform-author-url';
export const GOOGLE_ADS_META_USER_ACCOUNT_NAME = 'google-adsense-account';

export const LIMIT_SIDE_PX = 450;
export const MIN_VALUE_WIDTH_PX = 120;
export const MIN_VALUE_HEIGHT_PX = 50;
export const MAX_VALUE_WIDTH_HEIGHT_PX = 1200;
export const DEFAULT_WIDTH_PX = isMobile() ? 300 : 460;
export const DEFAULT_HEIGHT_PX = isMobile() ? 250 : 280;
export const sectionNotificationsTypes = [
  SectionNotificationType.default,
  SectionNotificationType.alert,
  SectionNotificationType.success,
];
